import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const styles = theme => ({
    paper: {
        marginBottom: theme.spacing(3),

        display: 'flex',
        flexDirection: 'column',
        flexGrown: 1,

        padding: theme.spacing(2)
    },

    expedition: {
        display: 'flex',
        alignItems: 'baseline'
    },

    dateExpedition: {
        margin: theme.spacing(0, 3, 0, 0),
        fontWeight: theme.typography.fontWeightMedium
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },

    container: {
        display: 'flex',
        width: '100%'
    },

    containerLeft: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginRight: theme.spacing(1)
    }
});

class InfosGenerales extends React.Component {

    renderContact(paramPrenom, paramNom, paramTelephone, paramEmail, paramCodePO) {
        const { classes } = this.props;

        let result = '';

        let prenom = '';
        if (paramPrenom !== null && paramPrenom !== undefined) {
            prenom = paramPrenom;
        }
        let nom = '';
        if (paramNom !== null && paramNom !== undefined) {
            nom = paramNom;
        }
        let telephone = '';
        if (paramTelephone !== null && paramTelephone !== undefined) {
            telephone = paramTelephone;
        }
        let email = '';
        if (paramEmail !== null && paramEmail !== undefined) {
            email = paramEmail;
        }
        let codePO = '';
        if (paramCodePO !== null && paramCodePO !== undefined) {
            codePO = paramCodePO;
        }

        if (prenom.length === 0 && nom.length === 0 && telephone.length === 0 && email.length === 0 && codePO.length === 0) {
            return (<Typography className={classes.bold} gutterBottom>&nbsp;</Typography>);
        } else {
            if (prenom.length > 0 || nom.length > 0) {
                if (prenom.length > 0) {
                    result = prenom;
                    if (nom.length > 0) {
                        result = result + ' ' + nom;
                    }
                } else {
                    result = nom;
                }
            }

            if (telephone.length > 0 || email.length > 0 || codePO.length > 0) {
                if (nom.length > 0) {
                    result = result + ' (';
                }

                if (telephone.length > 0) {
                    result = result + telephone;

                    if (email.length > 0) {
                        result = result + ' / ' + email;
                    }

                    if (codePO.length > 0) {
                        result = result + ' / ' + codePO;
                    }
                } else {
                    result = result + email;

                    if (email.length > 0) {
                        result = result + ' / ' + codePO;
                    } else {
                        result = result + codePO;
                    }
                }

                if (nom.length > 0) {
                    result = result + ')';
                }
            }

            return (<Typography className={classes.bold} gutterBottom>{result}</Typography>);
        }
    }

    render() {
        const { classes, infosGenerales } = this.props;

        return (
            <React.Fragment>
                {infosGenerales.piece && (
                    <Paper className={classes.paper}>
                        <Typography>
                            Expédition demandée le <span className={classes.dateExpedition}> {infosGenerales.piece.dateExpedition}</span>

                            Concerne la pièce <span className={classes.bold}> {infosGenerales.piece.numeroPiece} - {infosGenerales.piece.numeroPreparation}</span>
                        </Typography>
                    </Paper>
                )}

                <Paper className={classes.paper}>
                    <Typography variant="h6" gutterBottom>Contacts client</Typography>

                    <div className={classes.container}>
                        <div className={classes.containerLeft}>
                            {(infosGenerales.suiviNomContact || infosGenerales.suiviTelephoneMobile || infosGenerales.suiviEmail) && <Typography gutterBottom>Suivi dossier après-vente : </Typography>}
                            {infosGenerales.donneurOrdreContact && <Typography gutterBottom>Donneur d'ordre (commande) : </Typography>}
                            {infosGenerales.piece && infosGenerales.piece.suiviColisTelephoneMobile && <Typography gutterBottom>Portable suivi colis commande : </Typography>}
                            {infosGenerales.client && (infosGenerales.client.telephoneMobile || infosGenerales.client.email) && <Typography gutterBottom>Contact client général : </Typography>}
                            {infosGenerales.client && <Typography gutterBottom>Client sans émargement : </Typography>}
                            {infosGenerales.client && <Typography gutterBottom>Consignes client : </Typography>}
                        </div>

                        <div>
                            {(infosGenerales.suiviNomContact || infosGenerales.suiviTelephoneMobile || infosGenerales.suiviEmail) &&  this.renderContact(null, infosGenerales.suiviNomContact, infosGenerales.suiviTelephoneMobile, infosGenerales.suiviEmail)}
                            {infosGenerales.donneurOrdreContact &&  this.renderContact(null, infosGenerales.donneurOrdreContact, infosGenerales.donneurOrdreTelephoneMobile, infosGenerales.donneurOrdreEmail)}
                            {infosGenerales.piece && infosGenerales.piece.suiviColisTelephoneMobile && this.renderContact(null, null, infosGenerales.piece.suiviColisTelephoneMobile, null) }
                            {infosGenerales.client && (infosGenerales.client.telephoneMobile || infosGenerales.client.email) && this.renderContact(null, null, infosGenerales.client.telephoneMobile, infosGenerales.client.email)}
                            {infosGenerales.client && <Typography className={classes.bold} gutterBottom>{infosGenerales.client.sansEmargement === true ? 'oui' : 'non'}</Typography>}
                            {infosGenerales.client && <Typography className={classes.bold} gutterBottom>{infosGenerales.client.observations}</Typography>}
                        </div>
                    </div>
                </Paper>

                <Paper className={classes.paper}>
                    <Typography variant="h6" gutterBottom>Contacts commerciaux</Typography>

                    <div className={classes.container}>
                        <div className={classes.containerLeft}>
                            <Typography gutterBottom>Emetteur dossier après-vente : </Typography>
                            {infosGenerales.preneurOrdre && <Typography gutterBottom>Preneur d'ordre : </Typography>}
                            {infosGenerales.atc && <Typography gutterBottom>ATC : </Typography>}
                            {infosGenerales.atcs && <Typography gutterBottom>Sédentaire : </Typography>}
                            {infosGenerales.responsable && <Typography gutterBottom>Responsable : </Typography>}
                            {infosGenerales.manager && <Typography gutterBottom>Manager : </Typography>}
                            {infosGenerales.compta && <Typography gutterBottom>Compta : </Typography>}
                        </div>

                        <div>
                            {infosGenerales.emetteur && this.renderContact(infosGenerales.emetteur.prenom, infosGenerales.emetteur.nom, infosGenerales.emetteur.telephone, infosGenerales.emetteur.email, infosGenerales.emetteur.codePO)}

                            {infosGenerales.preneurOrdre && this.renderContact(infosGenerales.preneurOrdre.prenom, infosGenerales.preneurOrdre.nom, infosGenerales.preneurOrdre.telephone, infosGenerales.preneurOrdre.email, infosGenerales.preneurOrdre.codePO)}

                            {infosGenerales.atc && this.renderContact(infosGenerales.atc.prenom, infosGenerales.atc.nom, infosGenerales.atc.telephone, infosGenerales.atc.email, '')}

                            {infosGenerales.atcs && this.renderContact(infosGenerales.atcs.prenom, infosGenerales.atcs.nom, infosGenerales.atcs.telephone, infosGenerales.atcs.email, infosGenerales.atcs.codePO)}

                            {infosGenerales.responsable && this.renderContact(infosGenerales.responsable.prenom, infosGenerales.responsable.nom, infosGenerales.responsable.telephone, infosGenerales.responsable.email, '')}

                            {infosGenerales.manager && this.renderContact(infosGenerales.manager.prenom, infosGenerales.manager.nom, infosGenerales.manager.telephone, infosGenerales.manager.email, '')}

                            {infosGenerales.compta && this.renderContact(infosGenerales.compta.prenom, infosGenerales.compta.nom, infosGenerales.compta.telephone, infosGenerales.compta.email, '')}
                        </div>
                    </div>
                </Paper>
            </React.Fragment>
        );
    }
}

InfosGenerales.propTypes = {
    classes: PropTypes.object.isRequired,

    infosGenerales: PropTypes.object.isRequired
};

export default withStyles(styles)(InfosGenerales);